import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { OSUpdate as MdmOsUpdate } from '@rocksoft/mdm-sdk-v2';
import type { CategoryAllowedOsUpdate } from '../../types/location-allowed-os-update.types';

@Component({
  selector: 'era-os-update-list-item',
  templateUrl: './os-update-list-item.component.html',
  styleUrls: ['./os-update-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent],
})
export class OsUpdateListItemComponent {
  readonly isEditing = input(false);
  readonly allowEditing = input(false);
  readonly osupdate = input.required<MdmOsUpdate | CategoryAllowedOsUpdate>();

  readonly deleted = output<MdmOsUpdate | CategoryAllowedOsUpdate>();

  public delete() {
    this.deleted.emit(this.osupdate());
  }
}
